import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { inboxService, InboxFilters, SentEmailFilters, UpdateResponseRequest } from '@services/inbox.service'

export function useInboxResponses(filters: InboxFilters = {}) {
  return useQuery({
    queryKey: ['inbox', 'responses', filters],
    queryFn: () => inboxService.getResponses(filters),
  })
}

export function useInboxStats() {
  return useQuery({
    queryKey: ['inbox', 'stats'],
    queryFn: () => inboxService.getInboxStats(),
    refetchInterval: 60000,
  })
}

export function useSentEmails(filters: SentEmailFilters = {}) {
  return useQuery({
    queryKey: ['inbox', 'sent', filters],
    queryFn: () => inboxService.getSentEmails(filters),
  })
}

export function useUpdateResponse() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateResponseRequest }) =>
      inboxService.updateResponse(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inbox'] })
    },
  })
}

export function useDeleteResponse() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => inboxService.deleteResponse(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inbox'] })
    },
  })
}

export function useSendReply() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: { subject: string; body: string } }) =>
      inboxService.sendReply(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inbox'] })
    },
  })
}
